import React from "react";
import "./CustomInput.css";

interface InputProps {
  text: string;
  onChange: (value: string) => void;
}

const CustomInput: React.FC<InputProps> = ({ text, onChange }) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newText = event.target.value;
    onChange(newText); // Call the parent-provided onChange handler
  };

  return (
    <input type="text" title="title" value={text} onChange={handleChange} className="custom-input-container"/>
  );
};

export default CustomInput;